import { InternalId } from '@edgebox/data-definition-kit';
import React from 'react';
import { ApiComponent, IApiComponentState } from '../../../services/ApiComponent';
import { Throbber } from '@edgebox/react-components';
import { Badge } from 'react-bootstrap';
import { SiteEnvironmentType } from '@edgebox/sync-core-data-definitions';

interface IProps {
  contractId?: InternalId;
  environmentType?: SiteEnvironmentType.Production | SiteEnvironmentType.Testing;
  badge?: boolean;
  warnIfEmpty?: boolean;
}

interface IState extends IApiComponentState {
  count?: number;
}

export class ViewProjectCount extends ApiComponent<IProps, IState> {
  async load() {
    const { contractId, environmentType } = this.props;
    const result = await this.api.syndication.projects.search({ contractId }, { itemsPerPage: 0 }, { type: environmentType });
    const count = result.totalNumberOfItems;

    return {
      count,
    };
  }

  render(): React.ReactElement {
    const { count } = this.state;
    const { badge, warnIfEmpty } = this.props;

    if (count === undefined) {
      return <Throbber />;
    }

    if (badge) {
      return <Badge bg={warnIfEmpty && !count ? 'danger' : 'light'}>{count === 1 ? '1 project' : `${count} projects`}</Badge>;
    }

    return <>{count.toString()}</>;
  }
}
